import { render } from "./Wisata.vue?vue&type=template&id=9a76bf28"
import script from "./Wisata.vue?vue&type=script&lang=js"
export * from "./Wisata.vue?vue&type=script&lang=js"

import "./Wisata.vue?vue&type=style&index=0&id=9a76bf28&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__